import React from "react";
import SkillsTable from "../table/SkillsTable";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import ReactMarkdown from "react-markdown";

interface SkillsComparisonProps {
    data: Data[],
    feedback?: string,
    text?: string
}

interface Data {
    groupTitle: string,
    totalPoint: number,
    totalQuestion: number,
    advice: string,
    avgPoint: number,
    stdevpPoint: number,
    deviation: number,
    exposition: string,
    isLowSkill?: string
}

const SkillsComparison: React.FC<SkillsComparisonProps> = ({ data, feedback, text }) => {
    return<>
        <div style={{fontSize: '16px'}}>
            <div className="pt-4">
                <div>
                        <span style={{whiteSpace: 'break-spaces' }}>
                        {text}
                        </span>
                </div>
            </div>
            <SkillsTable data={data}/>
            {
                feedback !== '' && feedback !== null &&
                <div className="pb-5 pt-4">
                    <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                        {feedback}
                    </ReactMarkdown>
                </div>
            }

        </div>
    </>
};

export default SkillsComparison;
